import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import CustomModal from "../../components/common/customModal";
import CustomInput from "../../components/common/inputField";
import { OurMotorCycle } from "../../types/dashboard";
import dashboardService from "../../services/DashboardServices";
import { showToast } from "../../components/common/toastNotification";

interface ourMotorCycleProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  updateMotorcycleData?: OurMotorCycle;
}

const OurMotorcycle: React.FC<ourMotorCycleProps> = ({
  open,
  onClose,
  onSave,
  updateMotorcycleData,
}) => {
  useEffect(() => {
    if (open) {
      if (updateMotorcycleData) {
        setFormData(updateMotorcycleData);
      } else {
        setFormData({
          id: null,
          title: "",
          url: "",
        });
      }
      setFormErrors({
        title: "",
        url: "",
      });
    }
  }, [open, updateMotorcycleData]);

  const [formData, setFormData] = useState<OurMotorCycle>({
    id: null,
    title: "",
    url: "",
  });
  const [formErrors, setFormErrors] = useState<OurMotorCycle>({
    title: "",
    url: "",
  });
  const validateForm = () => {
    const errors: OurMotorCycle = {};
    const urlRegex =
      /^(https?:\/\/)(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(\/[^\s]*)?$/i;

    if (!formData.title?.trim()) {
      errors.title = "Title is required.";
    }

    const url = formData.url?.trim() || "";
    if (!url) {
      errors.url = "URL is required.";
    } else if (!urlRegex.test(url)) {
      errors.url = "Enter a valid URL.";
    }

    setFormErrors({
      title: errors.title || "",
      url: errors.url || "",
    });

    return Object.keys(errors).length === 0;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSaveData = async () => {
    if (!validateForm()) return;

    try {
      const inputData = {
        id: formData.id,
        title: formData.title,
        url: formData.url,
      };

      const apiCall = formData.id
        ? dashboardService.updateMotorCycleData(inputData)
        : dashboardService.addMotorCycleData(inputData);

      await apiCall
        .then((response) => {
          if (response && response.data) {
            showToast(response.data.message, "success");
            setFormData({
              id: 0,
              title: "",
              url: "",
            });
            onSave();
            onClose();
          } else {
            showToast(response?.data?.message || "Error occurred", "error");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <CustomModal
      open={open}
      handleClose={onClose}
      onSave={handleSaveData}
      title="Our Motorcycle"
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <CustomInput
            label="Title"
            type="text"
            name="title"
            placeholder="Enter Title"
            value={formData.title}
            onChange={handleChange}
            error={formErrors.title}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomInput
            label="URL"
            type="text"
            name="url"
            placeholder="Enter URL"
            value={formData.url}
            onChange={handleChange}
            error={formErrors.url}
          />
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default OurMotorcycle;
